import { forwardRef, KeyboardEvent } from "react";

import * as theme from "./AIPromptInput.css";

interface AIPromptInputTextareaProps {
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
    onSubmit: () => void;
    disabled: boolean;
}

export const AIPromptInputTextArea = forwardRef<
    HTMLTextAreaElement,
    AIPromptInputTextareaProps
>(({ placeholder, value, onChange, onSubmit, disabled }, ref) => {
    const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            onSubmit();
        }
    };

    return (
        <textarea
            ref={ref}
            className={theme.textarea}
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={disabled}
        />
    );
});
